/**
 * Cliente do backend TKWS — usado pelo login app só na reconciliação de primeiro
 * login Microsoft (ADR-055).
 *
 * O Vite dev proxy roteia `/api/*` → backend (http://localhost:8080). Em prod, o
 * gateway/edge faz o mesmo. Diferente do Zitadel, aqui NÃO há injeção de PAT: o
 * endpoint é público e o intent token é a credencial one-shot.
 */
// Mesma base do resto do app (tkws-api-client.ts): aponta direto para a API.
// Em dev o vite proxy `/api`→localhost:8080 também cobre, mas usar VITE_API_URL
// evita depender do proxy — em prod (Cloudflare Pages estático) `/api` relativo
// bateria no próprio host do SPA e retornaria 405.
const API_BASE = `${import.meta.env.VITE_API_URL ?? 'http://localhost:8080'}/api`;

/**
 * Resolve o `zitadelUserId` do shell user convidado a partir de um IdP intent
 * concluído. O backend troca o intent pelo email verificado da conta externa
 * (server-side) e devolve o usuário — o browser nunca escolhe o userId, evitando
 * sequestro de conta.
 *
 * @returns o `zitadelUserId`, ou `null` se não houver convite para a conta (404).
 * @throws Error em falhas de rede ou respostas inesperadas (≠ 200/404).
 */
export async function resolveIdpUser(
  idpIntentId: string,
  idpIntentToken: string,
): Promise<string | null> {
  const res = await fetch(`${API_BASE}/v1/invites/resolve-idp-user`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ idpIntentId, idpIntentToken }),
  });

  // 404 = nenhum convite para o email da conta Microsoft → não é erro técnico.
  if (res.status === 404) {
    return null;
  }
  if (!res.ok) {
    throw new Error(`resolve-idp-user falhou com status ${res.status}`);
  }

  const body = (await res.json().catch(() => ({}))) as { zitadelUserId?: string };
  return body.zitadelUserId ?? null;
}
